import { Injectable, Inject } from "@angular/core";
//import { Http, Headers, Response, URLSearchParams } from '@angular/http';
import { AppConfig } from "src/environments/appconfig";
import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { ParametroPaginacionGenerico } from "src/app/util/ParametroPaginacionGenerico";
import { FiltroPersonamast } from "../dominio/FiltroPersonamast";
import { DtoPersonamast } from "../dominio/DtoPersonamast";
import { UHttpsClient } from "../../../../seguridad/seguridad/uhttpsClient";

@Injectable()
export class PersonamastServicio {

    private url = `${this.config.getEnv('proxy')}spring/core/personamast/`;
    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    constructor(private http: UHttpsClient, private config: AppConfig) { }

    public listarPaginacion(filtro: FiltroPersonamast): Promise<ParametroPaginacionGenerico> {
        return this.http.post(`${this.url}listarPaginacion`, filtro,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as ParametroPaginacionGenerico;
            })
            .catch(error => new ParametroPaginacionGenerico());
    }

    public listarPaginacionCliente(filtro: FiltroPersonamast): Promise<ParametroPaginacionGenerico> {
        return this.http.post(`${this.url}listarPaginacionCliente`, filtro,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as ParametroPaginacionGenerico;
            })
            .catch(error => new ParametroPaginacionGenerico());
    }


    public listarClientes(busqueda: string): Promise<DtoPersonamast[]> {
        const params = new HttpParams().set('busqueda', busqueda);

        return this.http.get(`${this.url}listarClientes`, { params,headers: this.headers })
            .toPromise()
            .then(response => {
                return response as DtoPersonamast[];
            })
            .catch(error => []);
    }


    public listarClientesPorVendedor(filtro: FiltroPersonamast): Promise<DtoPersonamast[]> {
        return this.http.post(`${this.url}listarClientesPorVendedor`, filtro,{headers: this.headers})
            .toPromise()
            .then(response => {
                return response as DtoPersonamast[];
            })
            .catch(error => []);
    }
}

